<div class="activity-bg-section">
    <div class="activity-section">
        <div class="activity-heading-section">
            <span>{{data.name}}</span>
            <div class="each-activity-header-action-section">
                <span class="activity-close-icon" (click)="close()">&times;</span>
            </div>
        </div>
    <div class="activity-content-section">
        <ng-container *ngIf="activity_data_loaded">

            <div class="profile-basic-info-section">
                <div>
                    <div class="profile-image-section">
                        <img [src]="base_url + activity_data.profile_pic" onerror="this.src='assets/user-profile.png'" class="profile-image" />
                    </div>
                    <div class="profile-meta-data-section">
                        <p class="profile-name">{{activity_data.first_name}} {{activity_data.last_name}}</p>
                        <div class="profile-status-section">
                            <span class="profile-status-active-tag" *ngIf="activity_data.advisor_status == 'Active'">Active</span>
                            <span class="profile-status-inactive-tag" *ngIf="activity_data.advisor_status != 'Active'">In-Active</span>
                        </div>
                        <div class="profile-social-section">
                            <img src="assets/ic-linkedin.png" class="each-profile-social-image" (click)="navigateToExternalLink(activity_data.linkedin_url)" />
                            <img src="assets/ic-twitter.png" class="each-profile-social-image" (click)="navigateToExternalLink(activity_data.twitter_url)" />
                            <img src="assets/ic-facebook.png" class="each-profile-social-image" (click)="navigateToExternalLink(activity_data.facebook_url)" />
                        </div>
                        <span class="profile-member-section">Advisor Since: {{activity_data.date_of_joining | date: "dd MMM yyyy"}}</span>
                    </div>
                </div>
                <div class="profile-recommendation-section">
                    <div class="each-profile-recommendation-section">
                        <span class="each-profile-recommendation-label">Predicted Segment</span>
                        <span class="segment-tag" [ngClass]="{'high-segment-tag': activity_data.segment == 'High', 'medium-segment-tag': activity_data.segment == 'Medium', 'low-segment-tag': activity_data.segment == 'Low'}">{{activity_data.segment}}</span>
                    </div>
                </div>

            </div>

            <ng-container *ngIf="data.activity_type == 3">
                <div class="profile-details-section">
                    <div class="profile-details-heading-section ">
                        <span>AI Summary</span>
                    </div>
                    <div class="profile-details-content-section ">
                        <div class="each-profile-details-section" style="width: 100%;">
                          <span [innerHTML]="ai_summary"></span>
                        </div>
                    </div>
                </div>
                <!-- <div class="profile-details-section">
                    <div class="profile-details-heading-section">
                        <span>Predicted Segment Summary</span>
                    </div>
                    <div class="profile-details-content-section ">
                        <div class="each-profile-details-section" style="width: 100%;">
                          <span [innerHTML]="predicted_segment_summary"></span>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="profile-details-section">
                    <div class="profile-details-heading-section ">
                        <span>AI Model Parameters</span>
                    </div>
                    <div class="profile-details-content-section ">
                        <div class="each-profile-details-section" style="width: 100%;">
                            <p class="each-profile-details-label">Objective</p>
                            <p class="each-profile-details-value">The primary objective of this model is to identify and rank wealth advisors based on their potential to succeed within the firm. By distinguishing between high-potential and low-potential advisors, the firm can optimize its talent management strategy by focusing training, mentoring, and resource allocation on advisors who are more likely to drive long-term business growth and client engagement.</p>
                            <p class="each-profile-details-value">The primary objective of this model is to analyze third-party advisor data and identify advisors currently working at other firms who are most likely to consider switching jobs. By scoring and ranking these advisors based on key characteristics, the firm can proactively target high-potential candidates for recruitment, optimize talent acquisition strategies, and attract advisors who are likely to drive business growth and client engagement within the organization.</p>
                        </div>
                        <div class="each-profile-details-section" style="width: 100%;">
                            <p class="each-profile-details-label">Features (Independent Variables)</p>
                            <p class="each-profile-details-value">The model leverages key advisor attributes that have been shown to influence potential success:</p>
                            <ul class='ai-feature-list'>
                                <li>Age: Older advisors are assumed to bring maturity, stability, and credibility, contributing positively.</li>
                                <li>Number of Licenses: Higher licensing levels indicate broader capabilities and compliance readiness.</li>
                                <li>Number of Certifications: Specialized certifications reflect skill depth, commitment to learning, and expertise.</li>
                                <li>Prior Experience (Years): Longer tenure in financial services signals domain expertise and client-handling capability.</li>
                                <li>Experience at Current Firm (Years): Stability at the current firm reflects loyalty, adaptability to organizational culture, and reliability.</li>
                                <li>States Registered: Wider state registration indicates broader market access, compliance capability, and willingness to expand reach.</li>
                                <li>Miles to Work (Commute Distance): Shorter commutes may contribute to better work-life balance, higher availability, and reduced burnout. Longer commutes may negatively affect stability.</li>
                                <li>Distance from Work (Commuting Distance): Measures the physical distance between the advisor’s residence and workplace. Shorter commuting distances may reduce stress and improve work-life balance, leading to greater productivity and stability. Conversely, longer commutes may increase attrition risk or impact client-facing availability.</li>
                                <li>Market Conditions (External Environment Indicator): Captures the prevailing economic and financial market environment in which the advisor operates (e.g., bullish vs. bearish trends, regional growth conditions). Advisors operating in favorable market conditions may find it easier to acquire and retain clients, while adverse conditions may pose additional challenges</li>
                            </ul>
                        </div>
                        <div class="each-profile-details-section" style="width: 100%;">
                            <p class="each-profile-details-label">Modeling Approach</p>
                            <p class="each-profile-details-value">The model was trained using historical advisor data with stratified sampling to ensure balanced representation of high- and low-potential advisors. Hyperparameters were optimized using grid search and cross-validation to achieve stable performance.</p>
                            <ul class='ai-feature-list'>
                                <li>Type: Supervised Machine Learning Classification</li>
                                <li>Algorithm: Random Forest Classifier</li>
                                <li>Reason for Selection:
                                    <ul class='ai-feature-list'>
                                        <li>Handles non-linear relationships and feature interactions effectively.</li>
                                        <li>Robust to overfitting compared to single decision trees.</li>
                                        <li>Provides feature importance scores for interpretability.</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div> -->
                <div class="profile-details-section" *ngFor="let profile_section of experience_fields_data">
                    <div class="profile-details-heading-section ">
                        <span>{{profile_section.name}}</span>
                    </div>
                    <div class="profile-details-content-section ">
                        <div class="each-profile-details-section" *ngFor="let profile_field of profile_section.fields">
                            <p class="each-profile-details-label">{{profile_field.name}}</p>
                            <p class="each-profile-details-value">{{getValue(profile_field, profile_field.key)}}</p>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="data.activity_type == 4">
                <div class="profile-details-section" *ngFor="let profile_section of firm_profile_fields_data">
                    <div class="profile-details-heading-section ">
                        <span>{{profile_section.name}}</span>
                    </div>
                    <div class="profile-details-content-section ">
                        <div class="each-profile-details-section" *ngFor="let profile_field of profile_section.fields">
                            <p class="each-profile-details-label">{{profile_field.name}}</p>
                            <p class="each-profile-details-value">{{getValue(profile_field, profile_field.key)}}</p>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="data.activity_type == 5">
                <div class="profile-details-section">
                    <table class="ai-table">
                        <thead>
                            <tr>
                                <th>Eligibility</th>
                                <th>Opportunity</th>
                                <th>Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <span *ngIf="activity_data.eligibility">Yes</span>
                                    <span *ngIf="!activity_data.eligibility">No</span>
                                </td>
                                <td>
                                    <span *ngIf="activity_data.opportunity">Yes</span>
                                    <span *ngIf="!activity_data.opportunity">No</span></td>
                                <td>{{activity_data.score}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!activity_data_loaded">
            <app-loader [loading_text]="'Loading Advisor Data'"></app-loader>
        </ng-container>

    </div>
    </div>
</div>
